module.exports = __webpack_public_path__ + "static/shuttlevision-cctv-school-bus-ticket-c40fbdc936f9baa2721ceb60c574ae6f.jpg";